@if (hasIssues()) {
<aside
  class="readiness-banner"
  [class.readiness-banner--error]="tier() === 'error'"
  [class.readiness-banner--warning]="tier() === 'warning'"
  role="region"
  [attr.aria-label]="'Readiness for ' + tabLabel()"
>
  <button
    type="button"
    class="readiness-banner__header"
    [attr.aria-expanded]="expanded()"
    (click)="toggle()"
  >
    <span class="readiness-banner__title">Readiness</span>
    <span class="readiness-banner__counts">
      @if (blockers().length > 0) {
      <span class="readiness-banner__count readiness-banner__count--error">
        {{ blockers().length }} must fix
      </span>
      } @if (warnings().length > 0) {
      <span class="readiness-banner__count readiness-banner__count--warning">
        {{ warnings().length }} should fix
      </span>
      }
    </span>
    <span
      class="readiness-banner__toggle-chev"
      [class.readiness-banner__toggle-chev--open]="expanded()"
      aria-hidden="true"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </span>
  </button>

  @if (expanded()) { @if (blockers().length > 0) {
  <section class="readiness-banner__section readiness-banner__section--error">
    <h4 class="readiness-banner__heading">
      <span class="readiness-banner__heading-icon" aria-hidden="true">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </span>
      Must fix ({{ blockers().length }})
    </h4>
    <ul class="readiness-banner__list">
      @for (issue of blockers(); track issueKey(issue)) {
      <li>
        <button
          type="button"
          class="readiness-banner__issue"
          [attr.data-issue-key]="issueKey(issue)"
          (click)="onIssueClick(issue)"
        >
          <span class="readiness-banner__issue-body">
            <span class="readiness-banner__issue-msg">{{ issue.message }}</span>
            @if (issue.sectionId || issue.fieldKey) {
            <span class="readiness-banner__issue-crumb">
              {{ issue.sectionId }} {{ issue.sectionId && issue.fieldKey ? '›' :
              '' }} {{ issue.fieldKey }}
            </span>
            }
          </span>
        </button>
      </li>
      }
    </ul>
  </section>
  } @if (warnings().length > 0) {
  <section class="readiness-banner__section readiness-banner__section--warning">
    <h4 class="readiness-banner__heading">
      <span class="readiness-banner__heading-icon" aria-hidden="true">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 9v4M12 17h.01" />
          <path
            d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          />
        </svg>
      </span>
      Should fix ({{ warnings().length }})
    </h4>
    <ul class="readiness-banner__list">
      @for (issue of warnings(); track issueKey(issue)) {
      <li>
        <button
          type="button"
          class="readiness-banner__issue"
          [attr.data-issue-key]="issueKey(issue)"
          (click)="onIssueClick(issue)"
        >
          <span class="readiness-banner__issue-body">
            <span class="readiness-banner__issue-msg">{{ issue.message }}</span>
            @if (issue.sectionId || issue.fieldKey) {
            <span class="readiness-banner__issue-crumb">
              {{ issue.sectionId }} {{ issue.sectionId && issue.fieldKey ? '›' :
              '' }} {{ issue.fieldKey }}
            </span>
            }
          </span>
        </button>
      </li>
      }
    </ul>
  </section>
  } }
</aside>
}
